import ISiteDiaryItemOrderViewModel from "interfaces/SiteDiary/ItemOrder/ISiteDiaryItemOrderViewModel";

const DetailsTemplate = (props: ISiteDiaryItemOrderViewModel): any => {
  const { quantity, size } = props;
  return (
    <span data-testid="details">
      <span>
        {quantity}
        {size && (
          <>
&nbsp;x&nbsp;
            {size}
          </>
        )}
      </span>
    </span>
  );
};
export default DetailsTemplate;
